/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/

import {
    PolymerElement,
    html
} from "@polymer/polymer/polymer-element.js";
import {
    mixinBehaviors
} from '@polymer/polymer/lib/legacy/class.js';
import {
    OEFieldMixin
} from "oe-mixins/oe-field-mixin.js";
//import '../behaviors/keyboard-accessibility.js';
/**
 * `appTermsCondition` element.It is used to display the terms and conditions and to capture user's acceptance
 * @customElement
 * @polymer
 * @demo node_modules/speedboat_ui/elements/demo/app-terms-condition-demo.html
 * @summary Technical component
*/
class appTermsCondition extends mixinBehaviors([accessibilityBehaviours.commonFunctions], PolymerElement) {
    static get properties() {
        return {
            displaylabel: {
                type: String,
                value: '',
                notify: true
            },
            /*  Variable to disable the checkbox for terms and conditions */
            disabled: {
                type: Boolean,
                value: true,
                notify: true
            },
            customArialabel: {
                type: String,
                notify: true
            },
            label: {
                type: String,
                notify: true
            },
            required: {
                type: Boolean,
                notify: true
            },
            /*  Variable to send parent component whether user has agreed or not */
            value: {
                type: String,
                notify: true
            },
            /*  Variable to check whether user has agreed or not */
            checkvalue: {
                type: Boolean,
                notify: true,
                value: false,
                observer: '_checkvalue'
            }
        };
    }

    static get template() {
        return html`
            <style include="app-styles">
                :root {
                  --paper-input-container-underline: {
                    display: none;
                  };
                  --paper-input-container-underline-focus: {
                    display: none;
                  };
                  --paper-input-container-underline-disabled: {
                    display: none;
                  };
                }
 
              paper-checkbox{
                  font-size: var(--a-font-size-s);
                  --paper-checkbox-unchecked-color: var(--divider-color);
                  --paper-checkbox-checked-color: var(--brand-color);
                  --paper-checkbox-checkmark-color: var(--primary-light-color);
                  --paper-checkbox-checked-ink-color: var(--brand-color);
                  --paper-checkbox-label-color: var(--secondary-dark-color);
                }
               app-dialog {
                --dialog-background-color: {
                    background-color: #2a6cde;
                }
                --dialog-text-color: {
                  color: #ffffff;
                }
                --app-dialog-width: 500px;
                --paper-dialog:{
                    
                    overflow:hidden !important;
                    }
              }
            </style>
     <div class="main-container mdl-cell--1-offset-tablet mdl-cell--6-col-tablet mdl-cell--9-col-desktop mdl-cell"
                wide-layout$="{{wide}}" extra-wide-layout$="{{extra-wide}}">
                <div class="list-card background-transparent" phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}"
                    elevation="0">
                    <div class="content">
                        <oe-hbox class="section-column">
                            <div class="outlineOffset cursor-pointer" on-tap="handleTermsConditionsdialog" tabindex="0">
                                <paper-checkbox aria-label$="{{getLabel('l_IAcceptTermsAndConditions')}}" id="termsCondition1" on-tap="handleTermsConditionsdialog" checked={{checkvalue}} class="checkbox-light-style light-checkbox" phone$="{{phone}}" tablet$="{{tablet}}" desktop$="{{desktop}}">
                                </paper-checkbox>
                            </div>
                            <div class="position-relative primary-dark-text-s">
                                <oe-i18n-msg class="primary-dark-color" id="termsMsg1" msgid="I have read the"></oe-i18n-msg>
                                <oe-i18n-msg class="outlineOffset underline primary-dark-color text-brand-color cursor-pointer" id="termsMsg1" on-tap="handleTermsConditionsdialog" msgid="l_onlyTemrsConditions" tabindex="0"></oe-i18n-msg>
                                <!--<a href="https://www.website.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer"
                                    class="underline primary-dark-color">
                                    <oe-i18n-msg id="temrsConditionslink" class="" msgid=""></oe-i18n-msg>
                                </a>&nbsp&nbsp-->
                            </div>
                        </oe-hbox>
                    </div>
                </div>
      </div>
      <app-dialog name="Terms and Conditions" id="dataLookUp" closevisible={{closevisible}} elementid="dataLookUpElement">
         <div style="max-height: 40vh;overflow-y: auto;">
            <div class="mdl-grid primary-dark-text-m text-align-left" id="tnccontent">
            
            <div class="outlineOffset mdl-cell mdl-cell--12-col" tabindex="0" >
            
            Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est, qui dolorem ipsum, quia dolor sit amet consectetur adipisci[ng]velit, sed quia non-numquam [do] eius modi tempora inci[di]dunt, ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum[d] exercitationem ullam corporis suscipitlaboriosam, nisi  
            </div>  
            
            </div>
                
        </div>
        <div class="mdl-grid content-align-center padding-t-zero">
            <paper-button id="app_data_ok_id" class="primary-button" on-keydown="" on-tap="handleaccept">
                <oe-i18n-msg msgid="Accept"></oe-i18n-msg>
            </paper-button>
        </div>
        <div class="mdl-grid"></div>
        </app-dialog>
       `;
    }
    constructor() {
        super();
    }
    /**
     * Use for one-time configuration of your component after local
     * DOM is initialized.
     */


    ready() {
        super.ready();
    }
    /** 
     * This function will open the terms and conditions dialog box
     * @param {string} imgs
     * @return {string}
    **/
    handleTermsConditionsdialog() {
        this.$.dataLookUp.$$("#dataLookUpElement").open();
    }
    /** 
     * This function will close the terms and conditions dialog box
     * @param {string} imgs
     * @return {string}
    **/
    handleaccept() {
        this.checkvalue = true;
        this.$.dataLookUp.$$("#dataLookUpElement").close();
    }
    /** 
     * This function will validate whether user accepted terms or not
     * @return {boolean}
    **/
    _validate() {
        var isValid = true;

        if (_.isUndefined(this.checkvalue) || !this.checkvalue) {
            isValid = false;
            this.fire('oe-show-error', "Please accept terms and conditions");
            // this.setValidity(false, 'wrongValue');

        }

        return isValid;
    }
    /** 
     * This function will update the user selection
    **/

    _checkvalue() {
        this.value = this.checkvalue ? "Y" : "N";
    }

}
customElements.define('app-terms-condition', OEFieldMixin(appTermsCondition));